import React, { useState, useEffect } from 'react';
import { mockAuthService } from '../../config/Mockauth';
import './Login.css';
import logo from '../../assets/crest.jpg'
import { useNavigate } from 'react-router-dom';

const Login = ({ onLoginSuccess }) => {

    const navigate = useNavigate();
    // const token = localStorage.getItem('auth_token')

    useEffect(() => {
    const token = localStorage.getItem('auth_token');
    if (token) {
       navigate("/dashboard");
    }
  }, [navigate]);

  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [loginError, setLoginError] = useState('');
  const [isRegisterMode, setIsRegisterMode] = useState(false);
  const [registerName, setRegisterName] = useState('');

  const validateForm = () => {
    const newErrors = {};

    if (!formData.email) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Email is invalid';
    }

    if (!formData.password) {
      newErrors.password = 'Password is required';
    } else if (formData.password.length < 6) {
      newErrors.password = 'Password must be at least 6 characters';
    }

    if (isRegisterMode && !registerName) {
      newErrors.name = 'Name is required';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
    
    if (loginError) {
      setLoginError('');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    setLoading(true);
    setLoginError('');

    try {
      let response;
      
      if (isRegisterMode) {
        response = await mockAuthService.register(
          registerName,
          formData.email,
          formData.password
        );
      } else {
        response = await mockAuthService.login(
          formData.email,
          formData.password
        );
      }

      console.log('Authentication successful!');
      navigate('/dashboard');
      
      if (onLoginSuccess) {
        onLoginSuccess('Authentication successful!');
      } else {
        window.location.reload();
      }
      
    } catch (error) {
      setLoginError(error.message || 'Authentication failed. Please try again.');
      console.error('Authentication error:', error);
    } finally {
      setLoading(false);
    }
  };

  const toggleMode = () => {
    setIsRegisterMode(!isRegisterMode);
    setErrors({});
    setLoginError('');
    setFormData({ email: '', password: '' });
    setRegisterName('');
  };

  // const fillDemoCredentials = () => {
  //   setFormData({
  //     email: 'demo@example.com',
  //     password: 'password123'
  //   });
  //   setLoginError('');
  //   setErrors({});
  // };

  return (
        <>
            <div className="login-container">
                <div className="login-card">
                    <div className="login-header">
                    <div className="logo">
                        {/* <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
                        <rect width="40" height="40" rx="8" fill="#3498db"/>
                        <path d="M20 10L28 16V24L20 30L12 24V16L20 10Z" fill="white"/>
                        </svg> */}
                        <img alt='logo' style={{width: '60px', height: '50px'}} src={logo} />
                    </div>
                    <h1>{isRegisterMode ? 'Create Account' : 'Welcome Back'}</h1>
                    <p>{isRegisterMode ? 'Sign up to get started' : 'Sign in to continue'}</p>
                    </div>

                    {/* {!isRegisterMode && (
                    <div className="demo-banner">
                        <svg width="16" height="16" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd"/>
                        </svg>
                        <span>Demo: demo@example.com / password123</span>
                        <button type="button" onClick={fillDemoCredentials} className="btn-fill-demo">
                        Fill
                        </button>
                    </div>
                    )} */}

                    {loginError && (
                    <div className="alert alert-error">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd"/>
                        </svg>
                        <span>{loginError}</span>
                    </div>
                    )}

                    <form onSubmit={handleSubmit} className="login-form">
                    {isRegisterMode && (
                        <div className="form-group">
                        <label htmlFor="name">Full Name</label>
                        <div className="input-wrapper">
                            <svg className="input-icon" width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd"/>
                            </svg>
                            <input
                            type="text"
                            id="name"
                            name="name"
                            value={registerName}
                            onChange={(e) => {
                                setRegisterName(e.target.value);
                                if (errors.name) setErrors(prev => ({ ...prev, name: '' }));
                            }}
                            placeholder="John Doe"
                            className={errors.name ? 'error' : ''}
                            />
                        </div>
                        {errors.name && <span className="error-message">{errors.name}</span>}
                        </div>
                    )}

                    <div className="form-group">
                        <label htmlFor="email">Email Address</label>
                        <div className="input-wrapper">
                        <svg className="input-icon" width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                            <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"/>
                            <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"/>
                        </svg>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            placeholder="you@example.com"
                            className={errors.email ? 'error' : ''}
                        />
                        </div>
                        {errors.email && <span className="error-message">{errors.email}</span>}
                    </div>

                    <div className="form-group">
                        <label htmlFor="password">Password</label>
                        <div className="input-wrapper">
                        <svg className="input-icon" width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd"/>
                        </svg>
                        <input
                            type={showPassword ? 'text' : 'password'}
                            id="password"
                            name="password"
                            value={formData.password}
                            onChange={handleChange}
                            placeholder="Enter your password"
                            className={errors.password ? 'error' : ''}
                        />
                        <button
                            type="button"
                            className="password-toggle"
                            onClick={() => setShowPassword(!showPassword)}
                        >
                            {showPassword ? (
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd" d="M3.707 2.293a1 1 0 00-1.414 1.414l14 14a1 1 0 001.414-1.414l-1.473-1.473A10.014 10.014 0 0019.542 10C18.268 5.943 14.478 3 10 3a9.958 9.958 0 00-4.512 1.074l-1.78-1.781zm4.261 4.26l1.514 1.515a2.003 2.003 0 012.45 2.45l1.514 1.514a4 4 0 00-5.478-5.478z" clipRule="evenodd"/>
                                <path d="M12.454 16.697L9.75 13.992a4 4 0 01-3.742-3.741L2.335 6.578A9.98 9.98 0 00.458 10c1.274 4.057 5.065 7 9.542 7 .847 0 1.669-.105 2.454-.303z"/>
                            </svg>
                            ) : (
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                                <path d="M10 12a2 2 0 100-4 2 2 0 000 4z"/>
                                <path fillRule="evenodd" d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z" clipRule="evenodd"/>
                            </svg>
                            )}
                        </button>
                        </div>
                        {errors.password && <span className="error-message">{errors.password}</span>}
                    </div>

                    <button type="submit" className="btn-primary" disabled={loading}>
                        {loading ? (
                        <>
                            <span className="spinner"></span>
                            {isRegisterMode ? 'Creating account...' : 'Signing in...'}
                        </>
                        ) : (
                        isRegisterMode ? 'Create Account' : 'Sign In'
                        )}
                    </button>
                    </form>

                    <div className="signup-link">
                    {isRegisterMode ? 'Already have an account?' : "Don't have an account?"}{' '}
                    <button disabled type="button" onClick={toggleMode} className="link-button">
                        {isRegisterMode ? 'Sign in' : 'Sign up'}
                    </button>
                    </div>
                </div>
            </div>
        </>
    
  );
}

export default Login;